export default __webpack_public_path__ + "media/images/Coins-8218aa5c05c8b119023c511471a977fa.png";